import type { Address } from '@morpho-org/blue-sdk'

export interface Point {
  title?: string
  label?: string
  value?: string
  link?: string
  noHoverCard?: boolean
}

export interface AddressPointsMapping {
  [address: Address]: Point[]
}

export interface ChainIdAddressPointsMapping {
  [chainId: string]: AddressPointsMapping
}

export interface PointsMapping {
  vaultsWithPoints: ChainIdAddressPointsMapping
  vaultsWithPointsOnMarket: ChainIdAddressPointsMapping
  vaultsWithPointsOnMarketCollateralToken: ChainIdAddressPointsMapping
  marketsWithPoints: ChainIdAddressPointsMapping
  marketsWithPointsOnCollateralToken: {
    [chainId: string]: AddressPointsMapping
  }
}

export const points: PointsMapping = {
  vaultsWithPoints: {
    '1': {
      //Re7 WETH (Re7WETH)
      '0x78Fc2c2eD1A4cDb5402365934aE5648aDAd094d0': [
        {
          title: 'Points',
          label: 'Ether.Fi'
        }
      ],
      //Gauntlet WBTC Core
      '0x443df5eEE3196e9b2Dd77CaBd3eA76C3dee8f9b2': [
        {
          title: 'LUX',
          label: 'Lombard',
          link: 'https://www.lombard.finance/app/rewards/'
        }
      ],
      //Re7 WBTC
      '0xE0C98605f279e4D7946d25B75869c69802823763': [
        {
          title: 'LUX',
          label: 'Lombard',
          link: 'https://www.lombard.finance/app/rewards/'
        }
      ],
      //MEV Capital WBTC
      '0x1c530D6de70c05A81bF1670157b9d928e9699089': [
        {
          title: 'LUX',
          label: 'Lombard',
          link: 'https://www.lombard.finance/app/rewards/'
        }
      ],

      //MEV Capital cbBTC (MCcbBTC)
      '0x98cF0B67Da0F16E1F8f1a1D23ad8Dc64c0c70E0b': [
        {
          title: 'LUX',
          label: 'Lombard',
          link: 'https://www.lombard.finance/app/rewards/'
        }
      ],
      //Gauntlet cbBTC Core
      '0xF587f2e8AfF7D76618d3B6B4626621860FbD54e3': [
        {
          title: 'LUX',
          label: 'Lombard',
          link: 'https://www.lombard.finance/app/rewards/'
        }
      ],
      //Re7 cbBTC
      '0xA02F5E93f783baF150Aa1F8b341Ae90fe0a772f7': [
        {
          title: 'LUX',
          label: 'Lombard',
          link: 'https://www.lombard.finance/app/rewards/'
        }
      ],
      //Gauntlet LBTC Core (gtLBTCc)
      '0xdC94785959B73F7A168452b3654E44fEc6A750e4': [
        {
          title: 'LUX',
          label: 'Lombard',
          link: 'https://www.lombard.finance/app/rewards/'
        }
      ],
      //Coinshift USDL (csUSDL)
      '0xbEeFc011e94f43b8B7b455eBaB290C7Ab4E216f1': [
        {
          title: 'Shift Points',
          label: 'Coinshift',
          link: 'https://coinshift.global/points'
        }
      ],
      //Coinshift USDC
      '0x7204B7Dbf9412567835633B6F00C3Edc3a8D6330': [
        {
          title: 'Shift Points',
          label: 'Coinshift',
          link: 'https://coinshift.global/points'
        }
      ],
      //Gauntlet USDC Core
      '0x8eB67A509616cd6A7c1B3c8C21D48FF57df3d458': [
        {
          title: 'Points',
          label: 'Resolv',
          link: 'https://app.resolv.xyz/points'
        }
      ],
      //Smokehouse USDC
      '0xBEeFFF209270748ddd194831b3fa287a5386f5bC': [
        {
          title: 'Points',
          label: 'Resolv',
          link: 'https://app.resolv.xyz/points'
        }
      ],
      //Smokehouse USDT
      '0xA0804346780b4c2e3bE118ac957D1DB82F9d7484': [
        {
          title: 'Points',
          label: 'Resolv',
          link: 'https://app.resolv.xyz/points'
        }
      ],
      //Apostro Resolv USDC
      '0x214B47C50057eFaa7adc1B1C2608C3751Cd77D78': [
        {
          title: 'Points',
          label: 'Resolv',
          link: 'https://app.resolv.xyz/points'
        }
      ],
      //Resolv USDC
      '0x132E6C9C33A62D7727cd359b1f51e5B566E485Eb': [
        {
          title: 'Points',
          label: 'Resolv',
          link: 'https://app.resolv.xyz/points'
        }
      ],
      //MEV Capital Resolv USR (MEV request)
      '0xD50DA5F859811A91fD1876C9461fD39c23C747Ad': [
        {
          title: 'Points',
          label: 'Resolv',
          link: 'https://app.resolv.xyz/points'
        }
      ],
      //Apostro Resolv USR
      '0x5085Dd6FAd07c12e38fae01bc2a4938d2C08B1Bc': [
        {
          title: 'Points',
          label: 'Resolv',
          link: 'https://app.resolv.xyz/points'
        }
      ],
      //9S Mount Kosciuszko USR (9S request)
      '0x00B6f2C15E4439749f192D10c70f65354848Cf4b': [
        {
          title: 'Points',
          label: 'Resolv',
          link: 'https://app.resolv.xyz/points'
        }
      ],
      //Apostro Ethena USDe (Apostro request)
      '0x4EDfaB296F8Eb15aC0907CF9eCb7079b1679Da57': [
        {
          title: 'Sats',
          label: 'Ethena',
          link: 'https://app.ethena.fi/opportunities?search=morpho'
        }
      ],
      //TAC cbBTC (Turtle Club request)
      '0xb5e4576C2FAA16b0cC59D1A2f3366164844Ef9E0': [
        {
          title: 'TAC Boost',
          label: 'Turtle Club',
          link: 'https://app.turtle.club/campaigns'
        }
      ],
      //TAC ETH (Turtle Club request)
      '0x0bB2751a90fFF62e844b1521637DeD28F3f5046A': [
        {
          title: 'TAC Boost',
          label: 'Turtle Club',
          link: 'https://app.turtle.club/campaigns'
        }
      ],
      //TAC USDC
      '0x1E2aAaDcF528b9cC08F43d4fd7db488cE89F5741': [
        {
          title: 'TAC Boost',
          label: 'Turtle Club',
          link: 'https://app.turtle.club/campaigns'
        }
      ],
      //Clearstar USDC Reactor
      '0x62fE596d59fB077c2Df736dF212E0AFfb522dC78': [
        {
          title: 'Points',
          label: 'Resolv',
          link: 'https://app.resolv.xyz/points'
        }
      ],
      //Metronome msUSD Vault
      '0x6859B34a9379122d25A9FA46f0882d434fee36c3': [
        {
          title: 'XP',
          label: 'Odyssey'
        }
      ],
      //Metronome msETH Vault
      '0x78B18E07dc43017fcEaabaD0751d6464c0F56b25': [
        {
          title: 'XP',
          label: 'Odyssey'
        }
      ],
      //Hakutora USDC Vault - Resolv request
      '0x974c8FBf4fd795F66B85B73ebC988A51F1A040a9': [
        {
          title: 'Points',
          label: 'Resolv',
          link: 'https://app.resolv.xyz/points'
        }
      ]
    },
    '8453': {
      //Gauntlet cbBTC Core (gtcbBTCc)
      '0x6770216aC60F634483Ec073cBABC4011c94307Cb': [
        {
          title: 'LUX',
          label: 'Lombard',
          link: 'https://www.lombard.finance/app/rewards/'
        }
      ],
      //Gauntlet LBTC Core
      '0x0D05e6ec0A10f9fFE9229EAA785c11606a1d13Fb': [
        {
          title: 'LUX',
          label: 'Lombard',
          link: 'https://www.lombard.finance/app/rewards/'
        }
      ],
      //Apostro Resolv USDC (Apostro request)
      '0xcdDCDd18A16ED441F6CB10c3909e5e7ec2B9e8f3': [
        {
          title: 'Points',
          label: 'Resolv',
          link: 'https://app.resolv.xyz/points'
        }
      ],
      //Apostro Resolv USR (Apostro request)
      '0xC484D83F667b779cc9907248101214235642258B': [
        {
          title: 'Points',
          label: 'Resolv',
          link: 'https://app.resolv.xyz/points'
        }
      ],
      //Re7 Resolv USR (Re7 + Resolv request)
      '0x00dfDb8C7295a03DCf1ADfF4D21eB5D9D19FB330': [
        {
          title: 'Points',
          label: 'Resolv',
          link: 'https://app.resolv.xyz/points'
        }
      ],
      //High Yield Clearstar USDC
      '0xE74c499fA461AF1844fCa84204490877787cED56': [
        {
          title: 'Points',
          label: 'Resolv',
          link: 'https://app.resolv.xyz/points'
        }
      ],
      //Metronome msETH Vault
      '0x43Cd00De63485618A5CEEBE0de364cD6cBeB26E7': [
        {
          title: 'XP',
          label: 'Odyssey'
        }
      ]
    },
    '999': {
      //Gauntlet USDe Core Vault - Hyperbeat request
      '0x5eEC795d919FA97688Fb9844eeB0072E6B846F9d': [
        {
          title: 'Hearts',
          label: 'Hyperbeat',
          link: 'https://app.hyperbeat.org/hearts'
        }
      ],
      //Gauntlet USDT0 Vault - Hyperbeat request
      '0x53A333e51E96FE288bC9aDd7cdC4B1EAD2CD2FfA': [
        {
          title: 'Hearts',
          label: 'Hyperbeat',
          link: 'https://app.hyperbeat.org/hearts'
        }
      ],
      //Gauntlet uETH Vault - Hyperbeat request
      '0x0571362ba5EA9784a97605f57483f865A37dBEAA': [
        {
          title: 'Hearts',
          label: 'Hyperbeat',
          link: 'https://app.hyperbeat.org/hearts'
        }
      ],
      //MEV Capital HYPE Vault - Hyperbeat request
      '0xd19e3d00f8547f7d108abFD4bbb015486437B487': [
        {
          title: 'Hearts',
          label: 'Hyperbeat',
          link: 'https://app.hyperbeat.org/hearts'
        }
      ],
      //MEV Capital USR Vault - Hyperbeat request
      '0xD3A9Cb7312B9c29113290758f5ADFe12304cd16A': [
        {
          title: 'Hearts',
          label: 'Hyperbeat',
          link: 'https://app.hyperbeat.org/hearts'
        }
      ],
      //Hyperithm USDT0 Vault - Hyperbeat request
      '0xe5ADd96840F0B908ddeB3Bd144C0283Ac5ca7cA0': [
        {
          title: 'Hearts',
          label: 'Hyperbeat',
          link: 'https://app.hyperbeat.org/hearts'
        }
      ],
      //MEV Capital USDT0 Vault - Hyperbeat request
      '0x3Bcc0a5a66bB5BdCEEf5dd8a659a4eC75F3834d8': [
        {
          title: 'Hearts',
          label: 'Hyperbeat',
          link: 'https://app.hyperbeat.org/hearts'
        }
      ],
      //Re7 USDT0 Vault - Hyperbeat request
      '0x51F64488d03D8B210294dA2BF70D5db0Bc621B0c': [
        {
          title: 'Hearts',
          label: 'Hyperbeat',
          link: 'https://app.hyperbeat.org/hearts'
        }
      ],
      //Re7 Hype Vault - Hyperbeat request
      '0x182b318A8F1c7C92a7884e469442a610B0e69ed2': [
        {
          title: 'Hearts',
          label: 'Hyperbeat',
          link: 'https://app.hyperbeat.org/hearts'
        }
      ],
      //Hyperithm HYPE Vault - Hyperbeat request
      '0x92B518e1cD76dD70D3E20624AEdd7D107F332Cff': [
        {
          title: 'Hearts',
          label: 'Hyperbeat',
          link: 'https://app.hyperbeat.org/hearts'
        }
      ],
      //Gauntlet HYPE Vault - Hyperbeat request
      '0x264a06Fd7A7C9E0Bfe75163b475E2A3cc1856578': [
        {
          title: 'Hearts',
          label: 'Hyperbeat',
          link: 'https://app.hyperbeat.org/hearts'
        }
      ]
    }
  },
  vaultsWithPointsOnMarketCollateralToken: {
    '1': {},
    '8453': {}
  },
  marketsWithPoints: {
    '1': {
      //rsETH / USDA (LLTV=77%)
      '0xa72f4af2570dca1b356aa6c1e6a804d0d3df5b23bb092189776d0dc652feabb4': [
        {
          title: 'Points',
          label: 'Kernel',
          link: 'https://kerneldao.com/kelp/dashboard/'
        },
        {
          title: 'Eigen'
        }
      ],
      //rsETH / WETH (LLTV=94.5%)
      '0xba761af4134efb0855adfba638945f454f0a704af11fc93439e20c7c5ebab942': [
        {
          title: 'Points',
          label: 'Kernel',
          link: 'https://kerneldao.com/kelp/dashboard/'
        },
        {
          title: 'Eigen'
        }
      ],
      //SolvBTC / USDC (LLTV=86%)
      '0x444327b909aa41043cc4f20209eefb2fbb37f1c38ff9ca312374a4ecc3f0a871': [
        {
          title: 'XP',
          label: 'Solv'
        }
      ],
      //hETH / WETH (LLTV=86%) - MEV Capital request
      '0x9507d68c9c8663bd134680005cc0b3d8a891fa95db1905268933ac6bbc1d1feb': [
        {
          title: 'Points',
          label: 'Hinkal'
        }
      ],
      //wstUSR / USR (LLTV=91.5%) - MEV request
      '0xcfe8238ad5567886652ced15ee29a431c161a5904e5a6f380baaa1b4fdc8e302': [
        {
          title: 'Points',
          label: 'Resolv',
          link: 'https://app.resolv.xyz/points'
        }
      ],
      //RLP / USR (LLTV=86%) - Apostro request
      '0x308cb8d01d8fe656ceaf4841abc62cee6587f9e46533622e30a0053337953432': [
        {
          title: 'Points',
          label: 'Resolv',
          link: 'https://app.resolv.xyz/points'
        }
      ],
      //aprUSR/USDC (LLTV=91.5%) - Apostro request
      '0x1def309fa6c5b6ee7044b67154f15872af6c7e240f1e103f6a46cd82fb351688': [
        {
          title: 'Points',
          label: 'Resolv',
          link: 'https://app.resolv.xyz/points'
        }
      ],
      //USR/USDC (LLTV=91.5%) - Resolv request
      '0x8e7cc042d739a365c43d0a52d5f24160fa7ae9b7e7c9a479bd02a56041d4cf77': [
        {
          title: 'Points',
          label: 'Resolv',
          link: 'https://app.resolv.xyz/points'
        }
      ],
      //wstUSR/USDC (LLTV=91.5%) - Resolv request
      '0xd9e34b1eed46d123ac1b69b224de1881dbc88798bc7b70f504920f62f58f28cc': [
        {
          title: 'Points',
          label: 'Resolv',
          link: 'https://app.resolv.xyz/points'
        }
      ],
      //USR/USDT (LLTV=91.5%) - Resolv request
      '0x0ec590b250f171c22d39958a55a0589091431fe90599d55409c39aeb01363cb0': [
        {
          title: 'Points',
          label: 'Resolv',
          link: 'https://app.resolv.xyz/points'
        }
      ],
      //RLP/USDC (LLTV=86%) - Resolv request
      '0xe1b65304edd8ceaea9b629df4c3c926a37d1216e27900505c04f14b2ed279f33': [
        {
          title: 'Points',
          label: 'Resolv',
          link: 'https://app.resolv.xyz/points'
        }
      ],
      //USR/USD0 (91.5%) - MEV Capital request
      '0xc1f8ab27abbe4defca7ba1cbc02f695df1f637760b490ff1466887dc3af6f398': [
        {
          title: 'Points',
          label: 'Resolv',
          link: 'https://app.resolv.xyz/points'
        }
      ],
      //wstUSR/USD0 (91.5%)- MEV Capital request
      '0xfaa104a391485a79cd2eb3a0ac33b20e4230a269c22fb8462c6301cb80fee407': [
        {
          title: 'Points',
          label: 'Resolv',
          link: 'https://app.resolv.xyz/points'
        }
      ],
      //eUSDe/USDe (91.5%) - Apostro request
      '0x140fe48783fe88d2a52b31705577d917628caaf74ff79865b39d4c2aa6c2fd3c': [
        {
          title: 'Points',
          label: 'Ethereal',
          link: 'https://deposit.ethereal.trade/points'
        }
      ],
      //syrupUSDC/USDC (91.5%) - MEV Capital request
      '0x729badf297ee9f2f6b3f717b96fd355fc6ec00422284ce1968e76647b258cf44': [
        {
          title: 'Drips',
          label: 'Syrup',
          link: 'https://app.maple.finance/earn/drips'
        }
      ],
      //MC-USR/USD0 (91.5%) - MEV Capital request
      '0xcc39b6c92fd03ac608b9239618db8b80a4a2034b0450bdf47b404229571312da': [
        {
          title: 'Points',
          label: 'Resolv',
          link: 'https://app.resolv.xyz/points'
        }
      ],
      //MC-USR/USDC (91.5%) - MEV Capital request
      '0x3889dee51674c6e728f7d05f11a3407c6853e433a0e63f8febbc45887a26a475': [
        {
          title: 'Points',
          label: 'Resolv',
          link: 'https://app.resolv.xyz/points'
        }
      ],
      //yUSD/USDC (91.5%) - Yield.Fi request
      '0x60154d71ec96b7aee2864326662cb731172f1ebd6ca0e64af9bc8659831ed0ff': [
        {
          title: 'Points',
          label: 'Yield.Fi',
          link: 'https://yield.fi/points'
        }
      ],
      //mEDGE/USDC (86%) - Midas request
      '0x0f8ff4fa22195841e7fd1e0520f650a4d71247f75b9a1eb4ecabe111776a118c': [
        {
          title: 'Extra Rewards',
          label: 'mEDGE'
        }
      ],
      //mMEV/USDC (91.5%) - Midas request
      '0xbf6687cb042a09451e66ebc11d7716c49fb8ccc75f484f7fab0eed6624bd5838': [
        {
          title: 'Extra Rewards',
          label: 'mMEV'
        }
      ],
      //mMEV/USDC (86%) - Midas request
      '0xa9abd614ac94eee663b472bac0f704ece4469c3ce12df1d84565c7781541793e': [
        {
          title: 'Extra Rewards',
          label: 'mMEV'
        }
      ],
      //mMEV/USR (91.5%) - Midas request
      '0x4987abb1971947da9be3a47a58cb846a57b8a33bb3db1b0b2c6a3599c8b3a576': [
        {
          title: 'Extra Rewards',
          label: 'mMEV'
        }
      ],
      //csUSDC/wUSDL (96.5%) - Coinshift request
      '0xa9d6a0caea685bb0099ba2d52a58fb7ed33a6447616c25df93bdb8330337a9c3': [
        {
          title: 'Shift Points',
          label: 'Coinshift',
          link: 'https://coinshift.global/points'
        }
      ],
      //sUSDEsUSDS/USDC (91.5%) - Hyperithm
      '0xe0800b3f305b167e65738adc54e03d48c7bf4fb03af2734b4a72034852ba4a7a': [
        {
          title: 'Sats',
          label: 'Ethena',
          link: 'https://app.ethena.fi/opportunities?search=morpho'
        }
      ],
      //upUSDC/USDC (91.5%) - Upshift
      '0xa0c6499787a7d046f91f2687558c021e2baae5a378885280a448183a926ef5f7': [
        {
          title: 'Points',
          label: 'Upshift',
          link: 'https://app.upshift.finance/points'
        }
      ],
      //Wrapped-LP-pUSDe-16OCT2025/USDC (91.5%) - Strata request
      '0xb79a07659c64f0d471663f0629bab0997206bebb31ecbd4c750e1dd7fa7bc09a': [
        {
          title: 'Points',
          label: 'Strata',
          link: 'https://deposit.strata.money/#/predeposit'
        },
        {
          title: 'Sats',
          label: 'Ethena',
          link: 'https://app.ethena.fi/opportunities?search=morpho'
        },
        {
          title: 'Points',
          label: 'Ethereal',
          link: 'https://deposit.ethereal.trade/points'
        }
      ],
      //Wrapped-LP-pUSDe-16OCT2025/USDT (86%) - Strata request
      '0xe09be287c4f6583dfef6aa61d71f6cc76062aa1294e79b5c7c0a69d69bc1dd72': [
        {
          title: 'Points',
          label: 'Strata',
          link: 'https://deposit.strata.money/#/predeposit'
        },
        {
          title: 'Sats',
          label: 'Ethena',
          link: 'https://app.ethena.fi/opportunities?search=morpho'
        },
        {
          title: 'Points',
          label: 'Ethereal',
          link: 'https://deposit.ethereal.trade/points'
        }
      ],
      //reUSD/USDC (91.5%) - Re.xyz
      '0x4565ac05d38b19374ccbb04c17cca60ca9353cd41824f0803d0fc7704f60eaed': [
        {
          title: 'Points',
          label: 'Re',
          link: 'https://app.re.xyz/points'
        }
      ],
      //ynETHx/msETH (91.5%) - Vesper
      '0xd2630c0ebf33ba83c82e8cd400a8e6345370238ca695ce58773b2d3e43de1b0a': [
        {
          title: 'XP',
          label: 'Odyssey'
        }
      ],
      //rswETH/msETH (94.5%) - Vesper
      '0x0d55c325847ed87d53506c2aca7de046cb59d8c22928fd55fb2790c4811d20db': [
        {
          title: 'XP',
          label: 'Odyssey'
        }
      ],
      //jrUSDe/USDC (91.5%) - Strata
      '0x54cebd0c5d5ad84f551a883991c39c470e081a20452eaef47eec2377ffae9f98': [
        {
          title: 'Points',
          label: 'Strata',
          link: 'https://deposit.strata.money/#/predeposit'
        },
        {
          title: 'Sats',
          label: 'Ethena',
          link: 'https://app.ethena.fi/opportunities?search=morpho'
        }
      ],
      //Wrapped-LP-srUSDe-15JAN2026/USDC (86%) - Strata
      '0x3f246a31d3583a4c0ab8d83ea46907b188b8b463edb1c45af62b6265335084ee': [
        {
          title: 'Points',
          label: 'Strata',
          link: 'https://deposit.strata.money/#/predeposit'
        },
        {
          title: 'Sats',
          label: 'Ethena',
          link: 'https://app.ethena.fi/opportunities?search=morpho'
        }
      ],
      //Wrapped-LP-jrUSDe-15JAN2026/USDC (86%) - Strata
      '0x7b6129564616bf5c2390d7c2b202d48fb1798146bdb4b90eb0dad035607a32ec': [
        {
          title: 'Points',
          label: 'Strata',
          link: 'https://deposit.strata.money/#/predeposit'
        },
        {
          title: 'Sats',
          label: 'Ethena',
          link: 'https://app.ethena.fi/opportunities?search=morpho'
        }
      ]
    },
    '130': {
      //rsETH/WETH (94.5%) - kelp request
      '0x5a2b9a157b1b212921845d53fa52ae828ad9bc240ebfc7d57addf7c8f4b4729a': [
        {
          title: 'Points',
          label: 'Kernel',
          link: 'https://kerneldao.com/kelp/dashboard/'
        }
      ],
      //rsETH/wstETH (94.5%) - kelp request
      '0x2174609f3cfb09992e1c83594bc28d343221be4539e8d88ca58371f92d3b884d': [
        {
          title: 'Points',
          label: 'Kernel',
          link: 'https://kerneldao.com/kelp/dashboard/'
        }
      ]
    },
    '8453': {
      //USDz / USDC (LLTV=86%)
      '0x58bf7ed35b5d213336a68a5a42dff58f03ceaf417edaad0fc53e046f1742e20e': [
        {
          title: 'z-points'
        }
      ],
      //wrsETH / WETH (LLTV=94.5%)
      '0x214c2bf3c899c913efda9c4a49adff23f77bbc2dc525af7c05be7ec93f32d561': [
        {
          title: 'Points',
          label: 'Kernel',
          link: 'https://kerneldao.com/kelp/dashboard/'
        },
        {
          title: 'Eigen'
        }
      ],
      //LBTC / cbBTC (LLTV=94.5%) - Stakestone request
      '0x30767836635facec1282e6ef4a5981406ed4e72727b3a63a3a72c74e8279a8d7': [
        {
          title: 'LUX',
          label: 'Lombard',
          link: 'https://www.lombard.finance/app/rewards/'
        }
      ],
      //LBTC / cbBTC (LLTV=91.5%) - BA/BP request
      '0x4944a1169bc07b441473b830308ffe5bb535c10a9f824e33988b60738120c48e': [
        {
          title: 'LUX',
          label: 'Lombard',
          link: 'https://www.lombard.finance/app/rewards/'
        }
      ],
      //USR / USDC (91.5%) - Gauntlet + Resolv request
      '0xff0f2bd52ca786a4f8149f96622885e880222d8bed12bbbf5950296be8d03f89': [
        {
          title: 'Points',
          label: 'Resolv',
          link: 'https://app.resolv.xyz/points'
        }
      ],
      //aprUSR /USDC (91.5%) - Apostro request
      '0xf4d219ed36d38634f89c992a1bc50e73324f9c5c663d29d089d3f8aa74c700f3': [
        {
          title: 'Points',
          label: 'Resolv',
          link: 'https://app.resolv.xyz/points'
        }
      ],
      //yoUSD/USDC (91.5%) - Yo request
      '0x1a3e69d0109bb1be42b80e11034bb6ee98fc466721f26845dc83b2aa8d979137': [
        {
          title: 'Points',
          label: 'YO',
          link: 'https://app.yo.xyz/points'
        }
      ],
      //yoETH/WETH (91.5%) - Yo request
      '0x94f344f8db8c950faa45206c269dd0c2787a86ae3a7b988423e1e6e8173ae269': [
        {
          title: 'Points',
          label: 'YO',
          link: 'https://app.yo.xyz/points'
        }
      ],
      //yUSD/USDC (91.5%) - Yield.Fi request
      '0xb609f1d824d70a2127092333f591080be01555535c61d93252dd778e1fa88920': [
        {
          title: 'Points',
          label: 'Yield.Fi',
          link: 'https://yield.fi/points'
        }
      ]
    },
    '42161': {
      //wstUSR/USDC - resolv request
      '0x06a5954e8222a1f4719934d370ac558b657c6a5321d6cae615127b6596d10d32': [
        {
          title: 'Points',
          label: 'Resolv',
          link: 'https://app.resolv.xyz/points'
        }
      ],
      //thBILL/USDC - Theo request
      '0x551dbcdcceaf9322986e0cddde993d49840522a9532dc441359acd98af8badff': [
        {
          title: 'Points',
          label: 'Theo',
          link: 'https://app.theo.xyz/'
        }
      ]
    }
  },
  marketsWithPointsOnCollateralToken: {
    '1': {
      //weETH
      '0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee': [
        {
          title: 'Points',
          label: 'Ether.FI'
        }
      ],
      //sUSDe
      '0x9D39A5DE30e57443BfF2A8307A4256c8797A3497': [
        {
          title: 'Sats',
          label: 'Ethena',
          link: 'https://app.ethena.fi/opportunities?search=morpho'
        }
      ],
      //USDe
      '0x4c9EDD5852cd905f086C759E8383e09bff1E68B3': [
        {
          title: 'Sats',
          label: 'Ethena',
          link: 'https://app.ethena.fi/opportunities?search=morpho'
        }
      ],
      //LBTC
      '0x8236a87084f8B84306f72007F36F2618A5634494': [
        {
          title: 'LUX',
          label: 'Lombard',
          link: 'https://www.lombard.finance/app/rewards/'
        }
      ]
    }
  },
  vaultsWithPointsOnMarket: {
    '1': {
      //yUSD/USDC (91.5%) - Yield.Fi request
      '0x60154d71ec96b7aee2864326662cb731172f1ebd6ca0e64af9bc8659831ed0ff': [
        {
          title: 'Points',
          label: 'Yield.Fi',
          link: 'https://yield.fi/points'
        }
      ],
      //stcUSD/USDC (91.5%) - CAP request
      '0xeb17955ea422baeddbfb0b8d8c9086c5be7a9cfdefb292119a102e981a30062e': [
        {
          title: 'Caps',
          label: 'CAP',
          link: 'https://cap.app/caps'
        }
      ],
      //PT-stcUSD-29JAN2026/USDC (91.5%) - CAP request
      '0x03f715ef1ae508ab3e1faf4dffdbf2a077d1f0ad10c5aad42cf4438d5e3328af': [
        {
          title: 'Caps',
          label: 'CAP',
          link: 'https://cap.app/caps'
        }
      ],
      //PT-cUSD-29JAN2026/USDC (91.5%) - CAP request
      '0x802ec6e878dc9fe6905b8a0a18962dcca10440a87fa2242fbf4a0461c7b0c789': [
        {
          title: 'Caps',
          label: 'CAP',
          link: 'https://cap.app/caps'
        }
      ],
      //sUSDf/USDC (91.5%) - Falcon Finance request
      '0xbed987dd46049adb1ff34de8ef761a9da3b08890fa7fff629ea9b66d049de823': [
        {
          title: 'Miles',
          label: 'Falcon Finance',
          link: 'https://app.falcon.finance/miles'
        }
      ],
      //sUSDf/USDf (96.5%) - Falcon Finance request
      '0xe8c9d076ee7e6fcadd34165c44c08fe61533e7ab4accbed76d7e7f7d5a011708': [
        {
          title: 'Miles',
          label: 'Falcon Finance',
          link: 'https://app.falcon.finance/miles'
        }
      ],
      //sUSDf/USDf (91.5%) - Falcon Finance request
      '0x2e09b73c35e0769bdf589a9556e6ac3c892485ea502ac8c445cec9e79b0378af': [
        {
          title: 'Miles',
          label: 'Falcon Finance',
          link: 'https://app.falcon.finance/miles'
        }
      ]
    },
    '130': {},
    '8453': {
      //yUSD/USDC (91.5%) - Yield.Fi request
      '0xb609f1d824d70a2127092333f591080be01555535c61d93252dd778e1fa88920': [
        {
          title: 'Points',
          label: 'Yield.Fi',
          link: 'https://yield.fi/points'
        }
      ]
    },
    '42161': {
      //thBILL/USDC - Theo request
      '0x551dbcdcceaf9322986e0cddde993d49840522a9532dc441359acd98af8badff': [
        {
          title: 'Points',
          label: 'Theo',
          link: 'https://app.theo.xyz/'
        }
      ]
    }
  }
}
